import React from "react"

import * as educationPlanStyle from "../styles/EducationPlan.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

export default function EducationPlan(props) {
  const { content } = props
  
  const title = ChildSelector.select(
    content,
    `education-plan-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const scheduleTable = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("education-plan-description")
  )[0]

  const radioName = props.className
    .trim()
    .split(/\s+/)
    .includes("icw-education-style")
    ? "education-style"
    : "education-plan"

  return (
    <>
      <div className={`row ${props.className} ${educationPlanStyle.wrapper}`}>
        <div className={`col-12 ${educationPlanStyle.holder}`}>
          <h1 className={`${educationPlanStyle.title}`}>{title}</h1>
        </div>
        <div className={`row ${educationPlanStyle.tableWrapper}`}>
          <div
            className={`col-12 ${educationPlanStyle.scheduleTable} `}
            dangerouslySetInnerHTML={{
              __html: scheduleTable,
            }}
          ></div>
        </div>
       {/*  <div className={`row ${educationPlanStyle.optionWrapper}`}>
          <div className={`col-12 col-lg-3 ${educationPlanStyle.option}`}>
            <label>
              <input
                className="form-check-input"
                type="checkbox"
                name={radioName}
              />
            </label>
          </div>
          <div className={`col-12 col-lg-3 ${educationPlanStyle.option}`}>
            <label>
              <input
                className="form-check-input"
                type="checkbox"
                name={radioName}
              />
            </label>
          </div>
          <div className={`col-12 col-lg-3 ${educationPlanStyle.option}`}>
            <label>
              <input
                className="form-check-input"
                type="checkbox"
                name={radioName}
              />
            </label>
          </div>
        </div> */}
      </div>
    </>
  )
}
